export class ExcluirFinanceiroNotaFiscalEntradaDialogData {
  numeroNota: string = '';
}
